<template>
<v-form>
  <v-card flat >
    <v-alert :value='true' v-if='actionRequest.status == 200' type='success' class='pa-2' dismissible >
      Meeting information saved
    </v-alert>
    <server-errors :request='actionRequest' v-if='actionRequest.status > 300' >
    </server-errors>
    <v-text-field
        v-model='appointment.zoom_join_url'
        :error-messages='actionRequest.result.meeting_url'
        persistent-hint
        hint='The url for your meeting'
        label='Meeting url' ></v-text-field >
    <v-text-field
      v-model='appointment.zoom_meeting_password'
      :error-messages='actionRequest.result.zoom_meeting_password'
      persistent-hint
      hint='(optional) password for your meeting (if relevant)'
      label='Meeting password' ></v-text-field >
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click='save' :loading='actionRequest.loading' >Save</v-btn>
    </v-card-actions>
  </v-card>
</v-form>
</template>
<script>
import ServerErrors from '@/components/ServerErrors'
export default {
  name: 'ManualOnlineMeetingForm',
  components: {ServerErrors},
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      appointment: {
        id: null,
        meeting_url: '',
        zoom_meeting_password: ''
      },
      actionRequest: {
        status: 0,
        result: {}
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.appointment = this.value }
      }
    }
  },
  computed: {
    practitionerId () {
      if (this.appointment) {
        return this.getObjectPath(this.appointment, 'practitioner.id', this.appointment.practitioner)
      }
    },
    payload () {
      return {
        appointments: this.appointment.id.toString(),
        practitioner_id: this.practitionerId,
        manually_set: true,
        meeting_url: this.appointment.zoom_join_url,
        meeting_password: this.appointment.zoom_meeting_password
      }
    }
  },
  methods: {
    save () {
      this.action(
        this.$appointmentguru,
        'practitioner',
        'appointments',
        null,
        'bulk_make_online',
        JSON.stringify(this.payload),
        this.actionRequest
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// ManualOnlineMeetingForm.vue?253fcddc